/* eslint-disable */
/* THIS FILE IS AUTOGENERATED, DO NOT EDIT IT! */

import * as Types from '../app/services/types.generated';

import { api } from 'app/services/missionStorageApi';
export type GetMissionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetMissionsQuery = { __typename?: 'Query', missions: Array<{ __typename?: 'Mission', id: string, name: string, createdAt: any, updatedAt: any, actions: Array<{ __typename?: 'Action', id: string }> }> };

export type GetMissionQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetMissionQuery = { __typename?: 'Query', mission?: { __typename?: 'Mission', id: string, name: string, createdAt: any, updatedAt: any } | null };

export type CreateMissionMutationVariables = Types.Exact<{
  input: Types.CreateMissionInput;
}>;


export type CreateMissionMutation = { __typename?: 'Mutation', createMission: { __typename?: 'Mission', id: string, name: string, createdAt: any, updatedAt: any } };

export type UpdateMissionMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  input: Types.UpdateMissionInput;
}>;


export type UpdateMissionMutation = { __typename?: 'Mutation', updateMission: { __typename?: 'Mission', id: string, name: string, updatedAt: any } };

export type DeleteMissionMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type DeleteMissionMutation = { __typename?: 'Mutation', deleteMission: boolean };

export type DeleteMissionsMutationVariables = Types.Exact<{
  ids: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type DeleteMissionsMutation = { __typename?: 'Mutation', deleteMissions: boolean };


export const GetMissionsDocument = `
    query GetMissions {
  missions {
    id
    name
    createdAt
    updatedAt
    actions {
      id
    }
  }
}
    `;
export const GetMissionDocument = `
    query GetMission($id: String!) {
  mission(id: $id) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export const CreateMissionDocument = `
    mutation CreateMission($input: CreateMissionInput!) {
  createMission(input: $input) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export const UpdateMissionDocument = `
    mutation UpdateMission($id: String!, $input: UpdateMissionInput!) {
  updateMission(id: $id, input: $input) {
    id
    name
    updatedAt
  }
}
    `;
export const DeleteMissionDocument = `
    mutation DeleteMission($id: String!) {
  deleteMission(id: $id)
}
    `;
export const DeleteMissionsDocument = `
    mutation DeleteMissions($ids: [String!]!) {
  deleteMissions(ids: $ids)
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetMissions: build.query<GetMissionsQuery, GetMissionsQueryVariables | void>({
      query: (variables) => ({ document: GetMissionsDocument, variables: (variables ?? {}) as Record<string, unknown> })
    }),
    GetMission: build.query<GetMissionQuery, GetMissionQueryVariables>({
      query: (variables) => ({ document: GetMissionDocument, variables })
    }),
    CreateMission: build.mutation<CreateMissionMutation, CreateMissionMutationVariables>({
      query: (variables) => ({ document: CreateMissionDocument, variables })
    }),
    UpdateMission: build.mutation<UpdateMissionMutation, UpdateMissionMutationVariables>({
      query: (variables) => ({ document: UpdateMissionDocument, variables })
    }),
    DeleteMission: build.mutation<DeleteMissionMutation, DeleteMissionMutationVariables>({
      query: (variables) => ({ document: DeleteMissionDocument, variables })
    }),
    DeleteMissions: build.mutation<DeleteMissionsMutation, DeleteMissionsMutationVariables>({
      query: (variables) => ({ document: DeleteMissionsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetMissionsQuery, useLazyGetMissionsQuery, useGetMissionQuery, useLazyGetMissionQuery, useCreateMissionMutation, useUpdateMissionMutation, useDeleteMissionMutation, useDeleteMissionsMutation } = injectedRtkApi;
